module.exports = __webpack_public_path__ + "static/img/nine7.a59cc6fb.jpg";